import { ApiRelatedOrderItem } from "../ordersGridTypes.types";
import { calculateApiItemsTotal } from "../utils";

const roundToCents = (value: number) => {
    const roundedValue = Math.round(Number((value * 100).toFixed(4))) / 100;
    return roundedValue;
};

export const roundOrderTotal = (orderItems: Array<ApiRelatedOrderItem>) => {
    const roundedTotal = roundToCents(calculateApiItemsTotal(orderItems));
    return roundedTotal;
};
